export const GAME_TIME_SECS = 120000;

/** Puntuación inicial del equipo (puntos), alineada con `group.model` en backend. */
export const INITIAL_GROUP_CAPITAL_M = 10;

/** Coste en puntos de usar la pista en los quizzes con comodín (esc. 2–4). */
export const QUIZ_HINT_COST_POINTS = 3;

/** Puntos mínimos de rúbrica para considerar acierto (avatar y mensaje positivos). */
export const QUIZ_RUBRIC_PASS_POINTS = 50;

export const ROUTES = {
	HOME: "/",
	REGISTER: "/register",
	PRESENTATION: "/presentation",
	START_GAME: "/start-game",
	START_GAME2: "/start-game2",
	START_GAME3: "/start-game3",
	START_GAME4: "/start-game4",
	START_GAME5: "/start-game5",
	TRANSITION_SCENARIOS: "/scenarios",

	SCENARIO1_INTRO: "/scenario1-intro",
	SCENARIO1_INTRO2: "/scenario1-intro2",
	SCENARIO1_INSTRUCTIONS: "/scenario1-instructions",

	SCENARIO2: "/scenario2",
	SCENARIO2_INTRO: "/scenario2-intro",
	SCENARIO2_QUIZ1: "/scenario2-quiz1",
	SCENARIO2_QUIZ2: "/scenario2-quiz2",
	SCENARIO2_QUIZ3: "/scenario2-quiz3",
	SCENARIO2_QUIZ4: "/scenario2-quiz4",
	SCENARIO2_QUIZ5: "/scenario2-quiz5",
	SCENARIO2_QUIZ6: "/scenario2-quiz6",
	SCENARIO2_CONTEXT1: "/scenario2-context1",
	SCENARIO2_CONTEXT2: "/scenario2-context2",
	SCENARIO2_CONTEXT3: "/scenario2-context3",
	SCENARIO2_CONTEXT4: "/scenario2-context4",
	SCENARIO2_CONTEXT5: "/scenario2-context5",
	SCENARIO2_CONTEXT6: "/scenario2-context6",
	SCENARIO2_FIN: "/scenario2-fin",
	

	SCENARIO3: "/scenario3",
	SCENARIO3_INTRO: "/scenario3-intro",
	SCENARIO3_QUIZ1: "/scenario3-quiz1",
	SCENARIO3_QUIZ2: "/scenario3-quiz2",
	SCENARIO3_QUIZ3: "/scenario3-quiz3",
	SCENARIO3_QUIZ4: "/scenario3-quiz4",
	SCENARIO3_QUIZ5: "/scenario3-quiz5",
	SCENARIO3_QUIZ6: "/scenario3-quiz6",
	SCENARIO3_CONTEXT1: "/scenario3-context1",
	SCENARIO3_CONTEXT2: "/scenario3-context2",
	SCENARIO3_CONTEXT3: "/scenario3-context3",
	SCENARIO3_CONTEXT4: "/scenario3-context4",
	SCENARIO3_CONTEXT5: "/scenario3-context5",
	SCENARIO3_CONTEXT6: "/scenario3-context6",
	SCENARIO3_FIN: "/scenario3-fin",

	SCENARIO4: "/scenario4",
	SCENARIO4_INTRO: "/scenario4-intro",
	SCENARIO4_QUIZ1: "/scenario4-quiz1",
	SCENARIO4_QUIZ2: "/scenario4-quiz2",
	SCENARIO4_QUIZ3: "/scenario4-quiz3",
	SCENARIO4_QUIZ4: "/scenario4-quiz4",
	SCENARIO4_QUIZ5: "/scenario4-quiz5",
	SCENARIO4_QUIZ6: "/scenario4-quiz6",
	SCENARIO4_QUIZ7: "/scenario4-quiz7",
	SCENARIO4_CONTEXT1: "/scenario4-context1",
	SCENARIO4_CONTEXT2: "/scenario4-context2",
	SCENARIO4_CONTEXT3: "/scenario4-context3",
	SCENARIO4_CONTEXT4: "/scenario4-context4",
	SCENARIO4_CONTEXT5: "/scenario4-context5",
	SCENARIO4_CONTEXT6: "/scenario4-context6",
	SCENARIO4_FIN: "/scenario4-fin",

	SCENARIO5: "/scenario5",
	SCENARIO5_INTRO: "/scenario5-intro",
	SCENARIO5_QUIZ1: "/scenario5-quiz1",
	SCENARIO5_QUIZ2: "/scenario5-quiz2",
	SCENARIO5_QUIZ3: "/scenario5-quiz3",
	SCENARIO5_QUIZ4: "/scenario5-quiz4",
	SCENARIO5_QUIZ5: "/scenario5-quiz5",
	SCENARIO5_QUIZ6: "/scenario5-quiz6",
	SCENARIO5_CONTEXT1: "/scenario5-context1",
	SCENARIO5_CONTEXT2: "/scenario5-context2",
	SCENARIO5_CONTEXT3: "/scenario5-context3",
	SCENARIO5_CONTEXT4: "/scenario5-context4",
	SCENARIO5_CONTEXT5: "/scenario5-context5",
	SCENARIO5_CONTEXT6: "/scenario5-context6",
	
	SCENARIO5_CONCLUSION: "/scenario5-conclusion",
	SCENARIO5_RESULTADOS: "/scenario5-resultados",
	SCENARIO5_FIN: "/scenario5-fin",

	SUPERTEST_INTRO: "/supertest-intro",
	SUPERTEST_INSTRUCTIONS: "/supertest-instructions",
	SUPERTEST: "/supertest",
	SUPERTEST_2: "/supertest-2",
	SUPERTEST_3: "/supertest-3",

	FINAL_SCENE: "/final-scene",
	CONGRATULATIONS: "/congratulations",
	END: "/end",
	RESULTS: "/results",
	GAMEOVER: "/gameover",

	WARMUP: "/warmup"
};

export const SCENARIOS = {
	SCENARIO_1: "---",
	SCENARIO_2: "65127bfe70cc5310ac640cbd",
	SCENARIO_3: "6a25b8c28da3adb9040ff724",
	SCENARIO_4: "6a25b8ce8da3adb9040ff725",
	SCENARIO_5: "6a25b8d98da3adb9040ff726",
	SUPERTEST: "---",
};

export const QUIZZES = {
	QUIZ1: "65127e987b2f5959ecc4104c",

	/** Escenario 2 · quiz 2 (orden de prioridad DnD). Debe existir un documento en `quizzes` con este `_id`. */
	SCENARIO2_PRIORITY_ORDER_QUIZ: "674e1c2d3f4a5b6c7d8e9f0a",

	QUIZ2: "6a25ba078da3adb9040ff72d",

	/** Escenario 3 · quiz 2 (coincidencias vs contradicciones). Crear documento en `quizzes` con este `_id`. */
	SCENARIO3_VERSIONS_COMPARE_QUIZ: "674f1a2b3c4d5e6f78901234",

	/** Escenario 3 · quiz 3 (cinco actuaciones prioritarias). Crear documento en `quizzes` con este `_id`. */
	SCENARIO3_ACTUATIONS_PRIORITY_QUIZ: "674f1a2b3c4d5e6f78901235",

	QUIZ3: "6a25ba178da3adb9040ff72e",
	QUIZ4: "651280137b2f5959ecc41063",

	QUIZ5: "6a25ba328da3adb9040ff730",
};

/* Sellos: IDs del juego de nutrición (no forman parte del mapa QUIZ1–QUIZ14 del escape room). */
const FIRST_STAMP_QUIZ_ID = "65127e987b2f5959ecc4104c";
const SECOND_STAMP_QUIZ_ID = "65127fac7b2f5959ecc41061";
const THIRD_STAMP_QUIZ_ID = "651280f97b2f5959ecc4107c";
const FOURTH_STAMP_QUIZ_ID = "6512814f7b2f5959ecc41083";
const FIFTH_STAMP_QUIZ_ID = "651282327b2f5959ecc4108c";

export const STAMPS_QUIZZES = [
	FIRST_STAMP_QUIZ_ID,
	SECOND_STAMP_QUIZ_ID,
	THIRD_STAMP_QUIZ_ID,
	FOURTH_STAMP_QUIZ_ID,
	FIFTH_STAMP_QUIZ_ID,
];

export const QUESTION_ALREADY_ANSWERED_BUTTON = `<div class="d-flex align-items-center justify-content-center px-3">
		AVANZAR
	</div>`;

export const QUESTION_ALREADY_ANSWERED_TEXT = `<div>
		<div class="txt22">Ya has resuelto esta prueba anteriormente.</div>
		<div class="txt22 mt-2">¡Sigue adelante!</div>
	</div>`;
